import React from "react";
import { isEmpty } from "lodash";
import { Modal, Col, Row } from "react-bootstrap";

import { EmptyBlock } from "components";
import { getFormattedDate } from "helpers";
import { AuroraOutcomeStatuses } from "types";

import styles from "./uwResultModal.module.scss";

type UWResultModalProps = {
	show: boolean;
	onHide: () => void;
	title: string;
	data: {
		created_at: string;
		outcome: string;
		outcome_reasons: string;
		details: string;
	};
};

const UWResultModal = ({ show, onHide, title, data }: UWResultModalProps) => {
	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				<Modal.Title as="h6" className="text-center">
					{title}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{isEmpty(data) ? (
					<Row>
						<Col className="mb-4">
							<EmptyBlock
								description="No records to display. The report is missing.
								Please run it manually."
							/>
						</Col>
					</Row>
				) : (
					<div className="mb-5">
						<Row className="mb-3">
							<Col>
								<div className={styles.label}>
									Date &amp; Time:
								</div>
							</Col>
							<Col>
								<div className={styles.value}>
									{getFormattedDate({
										date: data?.created_at,
									}) || ""}
								</div>
							</Col>
						</Row>
						<Row className="mb-3">
							<Col>
								<div className={styles.label}>
									Alloy Outcome:
								</div>
							</Col>
							<Col>
								<div className={styles.value}>
									{AuroraOutcomeStatuses?.getByName?.(
										data?.outcome,
									)?.displayName || ""}
								</div>
							</Col>
						</Row>
						<Row className="mb-3">
							<Col>
								<div className={styles.label}>
									Outcome Reasons:
								</div>
							</Col>
							<Col>
								<div className={`${styles.value} text-break`}>
									{data?.outcome_reasons}
								</div>
							</Col>
						</Row>
						{data?.details && (
							<Row className="mb-3">
								<Col>
									<div className={styles.label}>Details:</div>
								</Col>
								<Col>
									<div className={styles.value}>
										{data?.details}
									</div>
								</Col>
							</Row>
						)}
					</div>
				)}
			</Modal.Body>
		</Modal>
	);
};

export default UWResultModal;
